import { createContext, useEffect, useState } from 'react';

import type {
  Breakpoint,
  BreakpointContextValue,
  BreakpointProviderProps,
  Breakpoints,
} from './types';

export const BreakpointContext = createContext<BreakpointContextValue | null>(null);

export const detectBreakpoint = (
  breakpoints: Breakpoints = {
    mobile: 768,
    tablet: 1200,
  }
): Breakpoint => {
  const width = window.innerWidth;

  if (width < breakpoints.mobile) {
    return 'mobile';
  } else if (width < breakpoints.tablet) {
    return 'tablet';
  }

  return 'desktop';
};

export const BreakpointProvider = ({
  breakpoints = {
    mobile: 768,
    tablet: 1200,
  },
  children,
}: BreakpointProviderProps) => {
  const [breakpoint, setBreakpoint] = useState(() => detectBreakpoint(breakpoints));

  useEffect(() => {
    const handleResize = () => {
      const breakpoint = detectBreakpoint(breakpoints);
      setBreakpoint(breakpoint);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoints]);

  return (
    <BreakpointContext.Provider
      value={{
        breakpoint,
      }}
    >
      {children}
    </BreakpointContext.Provider>
  );
};

export * from './hooks';
